// import cookie from '../../lib/cookie.js'
import '../assets/scss/accounts.scss'
import AccountAdd from "./pages/AccountAdd"
import AccountEdit from "./pages/AccountEdit"
import Spinner from 'vue-simple-spinner'
import Vue from "vue"
import {ACL_REQUEST} from '../store/actions/acl'
import {unsetUserACLs} from '../store/persist/acl'
import { mapState } from 'vuex'


export default {
	components: {
		AccountAdd,
		AccountEdit,
		Spinner
	},
	computed: mapState({
		// arrow functions can make the code very succinct!
		acls: state => state.acl.acls
	}),
	watch: {
		showStatus(a, b) {
			if (a !== b) {
				this.setStatusFilter();
			}
		},
		perPage(a, b) {
			if (a !== b) {
				// this.clearSelected();
			}
		},
		currentPage(a, b) {
			if (a !== b) {
				// this.clearSelected();
			}
		},
		filter(a, b) {      
			if (a !== b) {
				// this.clearSelected();
			}
		}
	},
	data() {
			return {
				loading:false,
				checkedItems: [],
				tableValues: [],
				accfields: [	
					{ key: 'USR_ID', label: 'ID',sortable: true },
					{ key: 'USR_NAME', label: 'Name',sortable: true },
					{ key: 'RESOURCES', label: 'Resources',sortable: true },
					{ key: 'actions', label: 'Actions', 'class': 'text-right'},
				],
				newaccount: {},
				currentPage:1,
				pageOptions: [ 5, 10, 20, 50, 100 ],
				filter: null,
				showeditor: false,
				rows: [],
				accounts:[],
				working:false,
				totalRows: 0,
				perPage: 20,	
				limit: 5,
				currentPage: 1,
			};
	},

	created: function () {
		let that = this
		this.loading = true;
		unsetUserACLs()
		this.$store.dispatch('ACL_REQUEST').then((result) => { })

		this.$http.get("/account/list", { headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken')}})
			.then(resp => {
				if(resp.data.error) {
					alert("Connection failed: " + resp.data.error)
					//resolve({'loginError':resp.data.error})
				}
				else {
					that.totalRows = parseInt(resp.data.length)
					that.rows = resp.data
					that.accounts = JSON.parse(JSON.stringify(that.rows))
					that.totalPages = (that.total == 0) ? 0 : Math.ceil(that.total / that.perpage)
					// that.showInventoryChunk(start)
					this.loading = false;
				}
			})
			.catch(err => {
				// localStorage.removeItem('shareXToken') // if the request fails, remove any possible user token if possible
				alert(err)
				this.loading = false;
			})
	},
	methods: {
		closeTheEditor() {
			this.showeditor = false;
		},
		showEditor() {
			this.showeditor = true;
		},
		details(index,item) {
			this.usrid = item.USR_ID || 0
			// this.site = this.inventory[index]
			this.showeditor = true;
		},



		findItemById(sid) {
			for(var i = 0;i < this.accounts.length;i++) {
				if(this.accounts[i].USR_ID == sid) {
					return this.accounts[i]
				}
			}				
		}	

	},
	

	mounted() {
			
	}
}
